module.exports = __webpack_public_path__ + "img/eoy-giving-banner.5064f1d2.jpg";